<template>
  <h2 class="pb-2 border-bottom">Serviços de Harmonização Facial</h2>
  <div class="fh-flex">
    <div class="fh-content">
      <p>A harmonização facial é um tratamento estético altamente procurado que melhora a simetria e o equilíbrio facial usando procedimentos minimamente invasivos.</p>

      <h5>Tratamentos Principais para Harmonização Facial</h5>
  <ul>
    <li>Botox & Neuromoduladores – Suaviza linhas de expressão (testa, pés de galinha, linhas de expressão)</li>
    <li>Preenchimentos Dérmicos (Ácido Hialurônico, Radiesse, Sculptra) – Contorna bochechas, linha do maxilar e lábios</li>
    <li>Contorno de Queixo & Linha do Maxilar – Aumenta a definição e corrige a assimetria</li>
    <li>Aumento Labial – Aumento labial natural ou volumoso</li>
    <li>Rinoplastia Não Cirúrgica – Preenchimento para corrigir saliências e refinar a forma do nariz</li>
    <li>Preenchimento de Têmpora & Olheiras – Trata o afundamento e olheiras para um visual jovem</li>
    <li>Aumento de Maçãs do Rosto – Adiciona estrutura e levanta a face média</li>
    <li>Potencializadores de Pele (Profhilo, PRP, Exossomos) – Melhora a hidratação e textura da pele</li>
    <li>Fios PDO (Opcional) – Levanta a pele flácida sem cirurgia</li>
  </ul>
  <p> Tratamentos combinados criam uma aparência mais natural e equilibrada ao invés de focar em uma única característica.</p>

  <h5>Visão Geral do Procedimento de Harmonização Facial</h5>
  <ul>
    <li>Consulta & Análise Facial
      <ul>
        <li>Avaliar objetivos do paciente e proporções faciais</li>
        <li>Identificar áreas que necessitam de volume, estrutura ou contorno</li>
        <li>Desenvolver um plano de tratamento personalizado</li>
      </ul>
    </li>
    <li>Procedimento & Técnica
      <ul>
        <li>Anestesia local ou creme anestésico (se necessário)</li>
        <li>Técnicas de injeção precisas para resultados naturais</li>
        <li>Melhoria imediata com tempo de inatividade mínimo</li>
      </ul>
    </li>
    <li>Cuidados Pós-Tratamento & Acompanhamento
      <ul>
        <li>Fornecer instruções de cuidados pós-tratamento (evitar pressão, minimizar inchaço)</li>
      </ul>
    </li>
  </ul>
    </div>
    <div class="fh-videos">
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08); margin-bottom: 1.5rem;" src="https://www.youtube.com/embed/dsy8tUMNyIs" title="YouTube Shorts: Harmonização Facial 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);" src="https://www.youtube.com/embed/LM2IEIQ-mC8" title="YouTube Shorts: Harmonização Facial 2" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FacialHarmonizationContentPtBR'
};
</script>

<style scoped>
.fh-flex {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 1.5rem;
}
.fh-content {
  flex: 1 1 340px;
  min-width: 0;
}
.fh-videos {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
@media (max-width: 900px) {
  .fh-flex {
    flex-direction: column;
    gap: 1.5rem;
  }
  .fh-videos {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;
    gap: 1rem;
  }
  .fh-videos iframe {
    width: 48vw;
    height: 270px;
    min-width: 160px;
    max-width: 100%;
  }
}
</style>
